/* @flow */

import {
  getBraindateCheckInURL,
  normalizeBraindate,
} from '@braindate/domain/lib/braindate/util';

import { parseResponse } from 'src/shared/app/base/util/ajaxUtils';
import { patchEntities } from 'src/shared/domain/base/action/entityActions';

import type { Braindate } from '@braindate/domain/lib/braindate/type';
import {
  markCheckInFetching,
  markCheckInSuccess,
} from 'src/shared/app/check-in/action/uiCheckInActions';
import type { GetState } from 'src/shared/core/type/reduxTypes';

export function checkInBraindate(braindate: Braindate) {
  return (dispatch: any, _: GetState, { post }: Object) => {
    dispatch(markCheckInFetching(braindate));
    return post(getBraindateCheckInURL(braindate))
      .then(parseResponse)
      .then((json) => {
        const normalizedData = normalizeBraindate(json);
        const { entities } = normalizedData;
        dispatch(markCheckInSuccess(braindate));
        dispatch(patchEntities(entities));
      });
  };
}
